<template>
  <div class="dialogReasonClosing">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="需求编号：">
        <span>ICP2020010101</span>
      </el-form-item>
      <el-form-item label="关闭原因：">
        <h3>因为各种原因关闭</h3>
        <p>1.需求为待服务商确认、待⽤户确认状态时，关闭需求时会⾃动关闭⽅案</p>
        <p>1.需求为待服务商确认、待⽤户确认状态时</p>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},
      rules: {},
    };
  },
};
</script>

<style lang="scss">
.dialogReasonClosing {
  width: 100%;
  .el-form {
    width: 100%;
    margin-top: 20px;
    .el-form-item {
      .el-form-item__content {
        .el-textarea__inner {
          height: 200px;
          width: 520px;
          h3 {
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(38, 38, 38, 1);
            line-height: 22px;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}
</style>
